export default "__VITE_ASSET__CDUX5D$m__"